import Cookies from 'js-cookie'

export const setLanguage = lang => {
const currentLang = Cookies.get('lang')
  if (currentLang === lang) {
    Cookies.set('localizationSelected', true, { expires: 365 })
  } else {
    Cookies.set('lang', lang)
    Cookies.set('localizationSelected', true, { expires: 365 })
    window.location.reload()
  }
}



// WEBPACK FOOTER //
// ./reducers/localization.js